// @flow
import { SET_PERMISSIONS } from 'action_types/AuthorizationActionTypes';
import { Store } from '@homie/flux';
import Dispatcher from 'dispatcher';
import { toGenericUrl } from 'auth/utils';

let _permissions = [];

export class AuthorizationStore extends Store {
  constructor() {
    super();
    Dispatcher.register(this.reducer);
  }

  getPermissions() {
    return _permissions;
  }

  reducer = (action: any) => {
    switch (action.type) {
      case SET_PERMISSIONS: {
        _permissions = action.payload.map(permission => ({
          url: toGenericUrl(permission.endpoint),
          method: permission.verb.toLowerCase()
        }));
        this.notify();
      }
    }
  };
}

export default new AuthorizationStore();
